import { Category } from '../../../types';
import { isImageSrcSVG } from '../../utils/isImageSrcSVG';
import { WebviewHTMLDocument } from '../types';


type HeaderStyleProps = {
  isDigestView: boolean;
  isYoutubeVideo: boolean;
  isPDFDigestPreview: boolean;
  isEmailOriginalView: boolean;
};

export type HeaderDocProps = Pick<
  WebviewHTMLDocument,
  'title' | 'nameOrDomain' | 'category' | 'languageCode' | 'image' | 'faviconUrl' | 'timeToRead' | 'publishedDateFormatted' | 'summary' | 'isAISummary' | 'author'>;

export type HeaderHTMLProps = {
  styleProps: HeaderStyleProps;
  doc: HeaderDocProps | null;
  isSummaryContainerInitiallyExpanded: boolean;
  showSummary: boolean;
};

/**
 * This allows us to get code highlight
 */
const html = String.raw;

const ChevronDownSvg = html`
  <svg width="9" height="5" viewBox="0 0 9 5" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.03033 0.46967C1.73744 0.176776 1.26256 0.176777 0.96967 0.46967C0.676777 0.762563 0.676777 1.23744 0.96967 1.53033L3.96967 4.53033C4.26256 4.82322 4.73744 4.82322 5.03033 4.53033L8.03033 1.53033C8.32322 1.23744 8.32322 0.762561 8.03033 0.469669C7.73744 0.176775 7.26256 0.176776 6.96967 0.469669L4.5 2.93934L2.03033 0.46967Z" fill="currentColor"/>
  </svg>
`;

const PdfSvg = `<svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg" class="pdf-icon-svg">
<path d="M34.4604 42.3059C34.8005 42.1767 35.1457 42.0491 35.496 41.9233C35.1745 41.7125 34.8905 41.525 34.6488 41.3653C34.6046 41.3361 34.5618 41.3078 34.5205 41.2806C34.5042 41.6248 34.4841 41.9667 34.4604 42.3059ZM34.5423 37.0039C34.3347 31.0403 33.1712 24.8186 31.3273 19.9215C30.0607 16.5575 28.3871 13.5836 26.2785 11.8133C25.1994 10.9073 23.9375 10.2601 22.5146 10.1213C21.0739 9.98068 19.6575 10.38 18.3249 11.2385L18.3119 11.2471C15.8387 12.8713 14.742 15.242 14.8511 17.9231C14.9545 20.4635 16.1266 23.1703 17.8535 25.7957C20.742 30.1872 25.5004 34.8286 31.0135 38.8626C31.0148 40.3925 30.9449 41.8893 30.7979 43.3192C30.7783 43.4837 30.7569 43.6717 30.7334 43.8812C23.2373 47.3995 18.8067 51.7977 16.8035 55.9785C15.5194 58.6586 15.2069 61.3281 15.8916 63.5618C16.5906 65.8422 18.3064 67.5394 20.6942 68.0834C23.8107 68.8038 26.2838 67.4934 28.0629 65.4084C29.7728 63.4046 30.9602 60.5835 31.8115 57.7721C33.0444 53.7008 33.6898 49.2257 34.042 46.3082C35.5456 45.6769 37.1834 45.0754 38.9633 44.5145C39.1025 44.4705 39.2411 44.4271 39.3792 44.3841C42.2133 46.1114 45.7846 48.1278 49.3195 49.6515C52.451 51.0013 55.7629 52.0595 58.5965 52.0633C60.0357 52.0652 61.4751 51.7962 62.7149 51.0391C63.9907 50.2601 64.9027 49.0551 65.4005 47.4841C66.1312 45.1704 66.1408 42.9203 64.955 41.0819C63.7846 39.2676 61.7299 38.2942 59.3281 37.8745C54.9138 37.103 48.2996 38.0113 39.884 40.507C38.4826 39.6276 37.3377 38.8717 36.5823 38.3729C36.5159 38.329 36.4525 38.2872 36.3922 38.2474L36.3822 38.2408C35.7604 37.8365 35.1466 37.4238 34.5423 37.0039ZM30.8026 34.2193C26.5599 30.8342 23.0345 27.1897 20.8299 23.838C19.2631 21.4559 18.4763 19.3917 18.4107 17.7782C18.3509 16.3077 18.8733 15.143 20.2609 14.2291C21.0315 13.7343 21.6553 13.6168 22.1686 13.6669C22.7012 13.7189 23.308 13.971 23.9879 14.5417C25.3971 15.7249 26.8027 18.0145 27.9933 21.1768C29.4043 24.9244 30.3929 29.569 30.8026 34.2193ZM44.0978 43.0294C50.725 41.3028 55.61 40.8412 58.7148 41.3838C60.6208 41.7169 61.5477 42.3718 61.9613 43.0131C62.3594 43.6302 62.5554 44.6631 62.0033 46.4113C61.7383 47.2468 61.3283 47.7117 60.8584 47.9986C60.3522 48.3077 59.6216 48.5021 58.6013 48.5008C56.5161 48.498 53.7521 47.6828 50.7297 46.38C48.4716 45.4067 46.1857 44.2141 44.0978 43.0294ZM30.2095 48.1269C29.8406 50.7097 29.2797 53.8408 28.4019 56.7397C27.5977 59.3953 26.5835 61.6539 25.353 63.096C24.1923 64.4562 22.9874 64.9577 21.4944 64.6119L21.4872 64.6103C20.4098 64.3654 19.6438 63.647 19.2977 62.5177C18.9368 61.3405 19.0166 59.6044 20.0163 57.5178C21.4115 54.6058 24.5492 51.1626 30.2095 48.1269Z" fill="#F9F9FA"/>
</svg>`;

const iconMap = {
  [Category.Email]: `<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.75 3C1.7835 3 1 3.74619 1 4.66667V11.3333C1 12.2538 1.7835 13 2.75 13H13.25C14.2165 13 15 12.2538 15 11.3333V4.66667C15 3.74619 14.2165 3 13.25 3H2.75ZM4.12654 5.23396C3.73065 4.97003 3.18506 5.06173 2.90793 5.43877C2.63081 5.81581 2.72709 6.33542 3.12298 6.59935L7.49798 9.51602C7.79926 9.71687 8.20026 9.71687 8.50154 9.51602L12.8765 6.59935C13.2724 6.33542 13.3687 5.81581 13.0916 5.43877C12.8145 5.06173 12.2689 4.97003 11.873 5.23396L7.99976 7.81611L4.12654 5.23396Z" />
    </svg>`,
  [Category.PDF]: `<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.82908 7.65768C7.58815 7.50584 7.38882 7.37556 7.24776 7.28335C7.23418 7.27448 7.22114 7.26595 7.20865 7.2578L7.20866 7.25778L7.204 7.25478C7.12767 7.20564 7.05197 7.15598 6.97693 7.10584C6.90836 5.79208 6.64223 4.44434 6.23136 3.36389C5.93526 2.58527 5.52359 1.83611 4.96139 1.3688C4.66871 1.12551 4.30492 0.934116 3.87758 0.89283C3.44223 0.85077 3.02786 0.973015 2.65914 1.20821L2.65912 1.20818L2.65302 1.21215C1.96319 1.6607 1.64253 2.33853 1.67342 3.09014C1.70153 3.77408 2.01488 4.45951 2.42492 5.07673C3.08136 6.06484 4.12558 7.08629 5.32579 7.97994C5.32148 8.18965 5.3106 8.39556 5.29279 8.59566C3.66341 9.39659 2.6448 10.3963 2.15823 11.4018C1.83247 12.0749 1.73248 12.7885 1.92792 13.4199C2.13026 14.0734 2.6354 14.5696 3.33037 14.7265C4.2267 14.9314 4.93758 14.5441 5.41605 13.9889C5.86173 13.4718 6.15178 12.7712 6.35028 12.1222C6.60415 11.2921 6.75145 10.3919 6.83827 9.73601C7.07501 9.64367 7.32701 9.5543 7.59505 9.46873C8.21907 9.83919 8.97695 10.2546 9.73041 10.5761C10.4518 10.8839 11.2658 11.1494 11.9953 11.1504C12.3702 11.1509 12.7801 11.082 13.1484 10.8593C13.5341 10.6262 13.8024 10.2674 13.9441 9.8245L13.9443 9.82376C14.132 9.23536 14.1597 8.58051 13.7935 8.0185C13.4361 7.46992 12.8348 7.21477 12.2341 7.11082C11.1731 6.92723 9.66551 7.13315 7.82908 7.65768ZM9.97506 8.85873C10.1115 8.9232 10.2483 8.98503 10.3846 9.04319C11.0549 9.32923 11.6148 9.4832 11.9975 9.48371C12.1789 9.48395 12.2597 9.44905 12.2862 9.43305C12.2865 9.43283 12.2869 9.43259 12.2874 9.43234C12.2978 9.4262 12.3271 9.40889 12.3566 9.317C12.4067 9.15973 12.4152 9.05663 12.4122 8.99782C12.4095 8.94678 12.3987 8.9308 12.3972 8.92849L12.3971 8.9283C12.3963 8.92711 12.3233 8.81769 11.9499 8.75308C11.5082 8.67665 10.8521 8.70009 9.97506 8.85873ZM4.99121 10.6975C4.92735 11.0094 4.8502 11.3283 4.75649 11.6347C4.58063 12.2097 4.37283 12.6464 4.15357 12.9008C3.96741 13.1168 3.84685 13.1351 3.70124 13.1017L3.6979 13.1009C3.60973 13.0811 3.55396 13.0365 3.52004 12.9269C3.47906 12.7946 3.46776 12.5218 3.65846 12.1278C3.8598 11.7117 4.27268 11.2017 4.99121 10.6975ZM5.13308 5.65735C5.02151 5.04435 4.86538 4.4608 4.67353 3.9563C4.41396 3.27373 4.12934 2.84444 3.89601 2.65049C3.79094 2.56315 3.73216 2.55321 3.7173 2.55177C3.71717 2.55176 3.71702 2.55174 3.71686 2.55173C3.70868 2.5509 3.66181 2.54616 3.5584 2.61147C3.37669 2.73058 3.33139 2.84431 3.33868 3.0217C3.34879 3.26779 3.47841 3.65057 3.81317 4.15447C4.13044 4.63206 4.58357 5.14622 5.13308 5.65735Z"/>
  </svg>`,
  [Category.Tweet]: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3018 4.86383C13.3099 4.98137 13.3099 5.09892 13.3099 5.21754C13.3099 8.83214 10.5582 13.0009 5.5266 13.0009V12.9987C4.04025 13.0009 2.58477 12.5751 1.3335 11.7724C1.54962 11.7984 1.76684 11.8114 1.98459 11.8119C3.21636 11.813 4.41292 11.3997 5.38198 10.6386C4.21142 10.6164 3.18494 9.8532 2.82635 8.73897C3.2364 8.81806 3.65891 8.80181 4.06137 8.69185C2.78519 8.43401 1.86705 7.31274 1.86705 6.01056C1.86705 5.99864 1.86705 5.98726 1.86705 5.97589C2.2473 6.18768 2.67306 6.30523 3.10857 6.31823C1.90659 5.51492 1.53608 3.9159 2.26193 2.66571C3.65078 4.3747 5.69994 5.41363 7.89968 5.52359C7.67922 4.57349 7.98039 3.57789 8.69107 2.91001C9.79284 1.87432 11.5257 1.92741 12.5613 3.02863C13.174 2.90784 13.7611 2.68305 14.2985 2.36454C14.0943 2.99776 13.6669 3.53564 13.096 3.87744C13.6382 3.81352 14.1679 3.66835 14.6668 3.44681C14.2996 3.99715 13.837 4.47653 13.3018 4.86383Z" fill="currentColor"/>
  </svg>`,
  [Category.EPUB]: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7 4.47107C6.50788 3.54257 5.09826 3 4 3C2.90174 3 1.55583 3.54257 1 4.47107V12.5313C1.92505 12.1153 2.96424 11.8819 4.0625 11.8819C5.52253 11.8819 6.87816 12.2944 8 13C9.12184 12.2944 10.4775 11.8819 11.9375 11.8819C13.0358 11.8819 14.075 12.1153 15 12.5313V4.47107C14.2454 3.31747 13.0983 3 12 3C10.9017 3 9.63104 3.40188 9 4.47107V9.45959C9 9.90553 8.48325 10.267 8 10.267C7.51675 10.267 7 9.94594 7 9.5V4.47107Z" fill="currentColor"/>
  </svg>`,
  [Category.Article]: `<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3 2.75C3 1.7835 3.74619 1 4.66667 1H8.48816C8.93018 1 9.35411 1.18437 9.66667 1.51256L12.5118 4.5C12.8244 4.82819 13 5.27331 13 5.73744V13.25C13 14.2165 12.2538 15 11.3333 15H4.66667C3.74619 15 3 14.2165 3 13.25V2.75ZM4.5 8C4.5 7.51675 5.03976 7 5.5 7H10.5C10.9602 7 11.5 7.64175 11.5 8.125C11.5 8.60825 10.9602 9 10.5 9H5.5C5.03976 9 4.5 8.48325 4.5 8ZM5.5 10C5.03976 10 4.5 10.5168 4.5 11C4.5 11.4832 5.03976 12 5.5 12H10.5C10.9602 12 11.5 11.4832 11.5 11C11.5 10.5168 10.9602 10 10.5 10H5.5Z" />
</svg>`, // TODO: do we have to add Category.Video here?
};

const SummaryContainer = (summary: string, isAISummary: boolean, isSummaryContainerInitiallyExpanded: boolean) => html`
  <div id="summary-container-wrapper" class="summary-container-wrapper ${isSummaryContainerInitiallyExpanded ? 'summary-container-expanded' : ''}">
    <div id="summary-container" class="summary-container">
      <div id="summary-top-line" class="summary-top-line ${isSummaryContainerInitiallyExpanded ? 'summary-top-line-expanded' : ''}"></div>
      <span class="document-header-tags tags-container"></span>
      <div class="summary-content">
      ${summary
  ? html`
            <p id="summary-text" class="summary-text">${summary}</p>
            ${isAISummary ? html`<span class="summary-attribution">Summarized by Ghostreader</span>` : ''}
          `
  : ''}
      </div>
    </div>
  </div>
`;

export const Metadata = (doc: HeaderDocProps, isDigestView: boolean, isEmailOriginalView: boolean, isSummaryContainerInitiallyExpanded: boolean, showSummary: boolean) => {
  const metadataItems = [
    html`<span class="metadata-author">${doc.author ?? 'Unknown'}</span>`,
    doc?.timeToRead && html`<span>${doc.timeToRead}</span>`,
    doc?.publishedDateFormatted &&
    html`<span>${doc.publishedDateFormatted}</span>`,
  ].filter(Boolean);

  const summaryBottomMargin = isDigestView ? 3 : isEmailOriginalView ? 7 : 0;

  return html`
    <div class="document-header-metadata-row">
      ${metadataItems.join(html`<span>&nbsp;·&nbsp;</span>`)}
    </div>
    ${!showSummary
      ? EmptyTagsContainer
      : html`
          <div class="summary-section">
            ${SummaryContainer(
              doc.summary,
              doc.isAISummary,
              isSummaryContainerInitiallyExpanded,
            )}
            <div id="summary-toggle" class="document-header-mobile-separator">
              ${!isDigestView
                ? html`<div
                    id="toggle-icon"
                    class="toggle-icon ${isSummaryContainerInitiallyExpanded
        ? 'toggle-icon-expanded'
        : ''}"
                  >
                    ${ChevronDownSvg}
                  </div>`
      : ''}
            </div>
          </div>
          <rw-spacer size="${summaryBottomMargin}" />
        `}
  `;
};


const EmptyTagsContainer = html`
  <rw-spacer />
  <span class="document-header-tags tags-container" style="display: none;"></span>
  <hr/>
`;
export const generateHeaderHtml = ({ styleProps, doc, isSummaryContainerInitiallyExpanded, showSummary }: HeaderHTMLProps) => {
  const { isDigestView, isYoutubeVideo, isPDFDigestPreview, isEmailOriginalView } = styleProps;

  const showNameOrDomain =
    doc?.nameOrDomain && doc?.category !== Category.EPUB && doc?.category !== Category.PDF;

  const contentLangAttribute = doc?.languageCode ? `lang="${doc.languageCode}"` : '';

  const showSecondaryHeaderImageInDigestView =
    isDigestView && doc?.image && doc?.image !== doc?.faviconUrl && !isImageSrcSVG(doc.image);
  const showSecondaryImage = doc && doc.image && doc.category !== Category.EPUB;
  const secondaryHeaderImage = isYoutubeVideo || isDigestView
    ? ''
    : `
    <div class="header-secondary-image-container ${showSecondaryImage ? '' : 'display-none'} ${
      showSecondaryHeaderImageInDigestView ? '' : 'hidden-image transparent'
    }">
      <img
        id="secondary-header-image"
        src="${doc?.image}"
        onload="window.onSecondaryHeaderImageLoaded()"
        onerror="window.onSecondaryHeaderImageError()"
      />
    </div>
  `;

  const getTitleHtml = ({ style = '' }: {style?: string;} = {}) => {
    const titleExpandedClass = isSummaryContainerInitiallyExpanded ? 'title-expanded' : '';
    return `<h1 class="document-header-title ${titleExpandedClass}" style="${style}" onclick="window.titleClicked()" ${contentLangAttribute}>${doc?.title}</h1>`;
  };

  return `
      <div class="image-background ${!isDigestView ? 'transparent' : ''}" id="header-image-container">
          <img
            id="header-image"
            src="${doc?.image}"
            class="${doc?.image ? '' : 'hidden-image'}"
            onload="window.onHeaderImageLoaded()"
            onerror="window.onHeaderImageError()"
          />
      </div>
      <div class="header-container ${doc?.category === Category.EPUB ? 'epub-header-container' : ''}">
        <div class="image-margin scrollbar" style="display:${isYoutubeVideo ? 'none' : ''}">
        </div>
        ${isPDFDigestPreview ? PdfSvg : ''}
        <div id="document-header" class="header">
          <div class="header-content">
            ${
    isYoutubeVideo
      ? getTitleHtml({ style: 'padding-top: 16px;' })
      : `<div class="header-top-row">
              ${
        showNameOrDomain
          ? `<span class="document-header-domain">
                  ${
            doc?.faviconUrl !== undefined
              ? `<img
                            class='document-header-domain-favicon'
                            id="favicon-image"
                            src="${doc?.faviconUrl}"
                            onerror="window.onFaviconError()"
                            onload="window.onFaviconLoaded()"
                          />`
              // claude eslint: mapped type cast for enum key indexing
              : (iconMap as { [K in Category]?: string })[doc?.category] ?? (iconMap as { [key: string]: string; })[Category.Article]
          }
                <span>${doc?.nameOrDomain ?? ''}</span>
                </span>`
          : '<span></span>'
      }
            </div>
            ${getTitleHtml()}
            `
  }
            ${doc !== null ? Metadata(doc, isDigestView, isEmailOriginalView, isSummaryContainerInitiallyExpanded, showSummary) : ''}
            ${secondaryHeaderImage}
          </div>
        </div>
      </div>
  `;
};
